export const AUTH_LOGOUT_EVENT = "husamhelper:auth:logout";
export const AUTH_LOGOUT_STORAGE_KEY = "husamhelper:auth:logout-at";

const expireCookie = (name: string) => {
  document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax`;
};

export const clearAuthCookies = () => {
  if (typeof document === "undefined") return;

  expireCookie("userToken");
  expireCookie("rememberMe");
};

export const broadcastAuthLogout = () => {
  clearAuthCookies();

  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(
      AUTH_LOGOUT_STORAGE_KEY,
      `${Date.now()}:${Math.random()}`,
    );
  } catch {
    // Cookie cleanup and the same-tab event are enough when storage is blocked.
  }

  window.dispatchEvent(new Event(AUTH_LOGOUT_EVENT));
};

export const isAuthLogoutStorageEvent = (event: StorageEvent) =>
  event.key === AUTH_LOGOUT_STORAGE_KEY;
